import React from 'react';
import './SquareCheckbox.css';

interface SquareCheckboxProps {
    id: string;
    name: string;
    value: string;
    checked: boolean;
    onChange: (value: string, checked: boolean) => void;
    label: string;
    disabled?: boolean;
    className?: string;
}

const SquareCheckbox: React.FC<SquareCheckboxProps> = ({
    id,
    name,
    value,
    checked,
    onChange,
    label,
    disabled = false,
    className = ''
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value, e.target.checked);
    };

    return (
        <div className={`square-checkbox-container ${className}`}>
            <div className="square-checkbox-wrapper">
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                    className="square-checkbox"
                />
                <label htmlFor={id} className="square-checkbox-label">
                    {label}
                </label>
            </div>
        </div>
    );
};

export default SquareCheckbox;
